import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const Info: FunctionalComponent<IIconProps> = ({ width = '16', height = '16', fill = '#707070', style = {} }) => {
  return (
    /*@ts-ignore*/
    <svg width={width} height={height} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM11 11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V11ZM12 8C12.5523 8 13 7.55228 13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7C11 7.55228 11.4477 8 12 8Z"
        fill={fill}
      />
    </svg>
  );
};

export default Info;
